import { createStore } from 'vuex';
import { IFacilityStore } from '@/store/modules/Facility';
import { ILandPLotStore } from '@/store/modules/LandPLot';
import { ICardSetingsStore } from '@/types/CardSettings';
import { IGalleryStore } from './modules/Gallery';

export interface IRootState {
    facilityStore: IFacilityStore;
    landPLotStore: ILandPLotStore;
    ICardSetingsStore: ICardSetingsStore;
    galleryStore: IGalleryStore;
}

export default createStore<IRootState>({});
